import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import intl from 'react-intl-universal'
import styles from './index.less';
import welcomeIcon from './assets/welcomeIcon.png';
import commentIcon from './assets/commentIcon.png';
import radio from './assets/radio.png';
import radioActive from './assets/radioActive.png';
import downArrow from './assets/downArrow.png'
import successIcon from './assets/successIcon.png';
import ChannelType from './components/channelType';
import DownSelectSearch from './components/DownSelectSearch';
import Satisfaction from './components/Satisfaction';
import { satisfactionList } from './components/Satisfaction/satisfactionList';
import {showToast} from './components/Toast'
import UrlParam from '../../../utils/UrlParam'
import { language } from '../../../utils/translation'
import {
  judgeQrCodeEffective,
  submitScanInfo,
  queryPublishAreaAndChannelType,
  queryRetailerByArea,
} from '../../../api/signIn'

enum ChannelIdType {
  RMS = "RMS",
  NEW_RETAIL = "NEW_RETAIL"
}
const SiteId = {
  1: intl.get('qrcode.signIn.xiaomiStore', { name: 'Xiaomi' }), // 直营店
  5: intl.get('qrcode.signIn.xiaomiAuthorizedStore', { name: 'Xiaomi' }), // 授权店
};

const WELCOMETEXT = intl.get('qrcode.signIn.welcomeText');

function SignInPage() {
  const retailerTimer = useRef<NodeJS.Timeout | null>(null);

  const [channel, setChannel] = useState('');
  const [mid, setMid] = useState('');

  const [qrCodeId, setQrCodeId] = useState('');

  // 二维码名称
  const [qrCodeName, setQrCodeName] = useState('');

  // 是否有小米账号radio
  const [isHaveMid, setIsHaveMid] = useState<boolean>(true);
  const [showSelectMid, setShowSelectMid] = useState<boolean>(true);
  
  // 渠道类型
  const [showChannelType, setShowChannelType] = useState(false);
  const [selectedChannelType, setSelectedChannelType] = useState('');
  const [selectedChannelTypeKey, setSelectedChannelTypeKey] = useState('');

  // 零售商名称
  const [showRetailer, setShowRetailer] = useState(false);
  const [selectedRetailer, setSelectedRetailer] = useState('');
  const [selectedRetailerKey, setSelectedRetailerKey] = useState('');
  const [retailerName, setRetailerName] = useState('');
  const [retailerList, setRetailerList] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState<number>(0);
  
  // 手动输入零售商名称
  const [retailer, setRetailer] = useState('');
  const [isLoadedRetailer, setIsLoadedRetailer] = useState(false)

  // 国家名称
  const [showCountry, setShowCountry] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedCountryKey, setSelectedCountryKey] = useState('');
  const [countryName, setCountryName] = useState('');
  const [isClickCountry, setIsClickCountry] = useState(false);
  // 请求零售商和提交接口的域名
  const [dnsName, setDnsName] = useState('');

  // 满意度列表
  const [satisfactionData, setSatisfactionData] = useState(satisfactionList);

  // 评论
  const [comment, setComment] = useState('');

  // 首选名称
  const [preferredName, setPreferredName] = useState('');

  // welcome text
  const [welcomeText, setWelcomeText] = useState(WELCOMETEXT);

  // 小米零售账号
  const [xiaomiRetailAccount, setXiaomiRetailAccount] = useState('');

  // 是否展示表单
  const [showForm, setShowForm] = useState(false);
  
  // 设置失败展示的文案
  const [failText, setFailText] = useState<string>('');

  // 渠道列表
  const [channelList, setChannelList] = useState<any[]>([]);

  // 国家列表
  const [publishAreaList, setPublishAreaList] = useState<any[]>([]);

  // trainingFeedback 是否展示评分模块  1是（app端透出评分模块）2否
  const [trainingFeedback, setTrainingFeedback] = useState<string>('1');

  // 零售商 原15条, 改成一百条的原因是因为后端那块儿查询改造需要时间, 临时改成100, 另外新增的逻辑是,如果返回的数据等于100时隐藏没有更多
  const PAGE_SIZE = 100;
  const [pageNo, setPageNo] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(PAGE_SIZE);

  // 岗位
  const [jobValue, setJobValue] = useState<string>('');
  const [jobTitle, setJobTitle] = useState<string>('');

  // 门店名称
  const [orgName, setOrgName] = useState<string>('');
  const [orgId, setOrgId] = useState<string>('');
  // 门店类型
  const [siteId, setSiteId] = useState<string>('');

  // 提交成功状态管理
  const [submitSuccess, setSubmitSuccess] = useState<boolean>(false);

  // 展示未选择为输入状态
  const [isAllEmptyShowTip, setIsAllEmptyShowTip] = useState<boolean>(false);

  const updateSatisfaction = (index: number, satisfaction: number) =>{
    setSatisfactionData(satisfactionData.map((item, i) => {
      return {
        ...item,
        satisfaction: i === index ? satisfaction : item.satisfaction
      }
    }))
  }

  const updateComment = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (value.length <= 300) {
      setComment(e.target.value);
    }
  }

  const updatePreferredName = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 100) return false;
    setPreferredName(e.target.value);
  }

  const updateRetailer = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 100) return false;
    setRetailer(e.target.value);
  }

  const updateXiaomiRetailAccount = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 100) return false;
    setXiaomiRetailAccount(e.target.value);
  }

  const getQrCodeEffective = (id: string, userTitle: number, channel: string, userType: string, countryKey?: string, mid?: string) => {
    judgeQrCodeEffective({
      id: id,
      userTitle: userTitle ? [userTitle] : [],
      userType: userType, // 用户类型  零售通用户 1     非零售通用户2
      channelType: channel,
      areaIdBelongUser: countryKey || '',
      language: language,
      mid: mid || ''
    }).then((res: any) => {
      if (res?.code === 0) {
        setShowForm(true)
        getQueryPublishAreaAndChannelType(id, countryKey)
      } else if (res?.code === 400080501) {
        setShowForm(false);
        setFailText(res?.message);
        (window as any).onetrack('track', 'view', {
          tip: '310.593.0.1.46886',
        })
      } else {
        setShowForm(false);
        setFailText(intl.get('qrcode.signIn.toast'));
        (window as any).onetrack('track', 'view', {
          tip: '310.593.0.1.46886',
        })
      }
    })
  }

  const getQueryPublishAreaAndChannelType = (id: string = '', countryKey?: string) => {
    queryPublishAreaAndChannelType({
      qrCodeId: id,
      language: language
    }).then((res: any) => {
      if (res?.code === 0) {
        setChannelList(res?.data?.channelList)
        setPublishAreaList(res?.data?.publishAreaList)
        if (countryKey) {
          setSelectedCountry(res?.data?.publishAreaList.find((item: any) => item.areaId === countryKey)?.areaName)
        } else if (res?.data?.publishAreaList.length === 1) {
          setSelectedCountry(res?.data?.publishAreaList[0].areaName)
          setSelectedCountryKey(res?.data?.publishAreaList[0].areaId)
          setDnsName(res?.data?.publishAreaList[0].dnsName)
        }
        if (res?.data?.channelList.length === 1) {
          setSelectedChannelType(res?.data?.channelList[0].channelName)
          setSelectedChannelTypeKey(res?.data?.channelList[0].channelId)
        }
      } else {
        setFailText(intl.get('qrcode.signIn.toast'))
      }
    })
  }

  // 获取链接后缀中的数据
  // ?channel=RMS&id=1&type=signIn&named=Huan%20Li&account=3150442052&jobValue=1&channelId=NEW_RETAIL&qrCodeName=test%20name&trainingFeedback=1&language=zh-CN&mid=1003&region=ID
  // trainingFeedback  1是（app端透出评分模块）2否（app端不透出评分模块）
  // &org_name= &siteId= 新零售使用的门店名称和门店类型
  const getUrlParamVal = () =>{
    try {
      const search = window?.location?.search || '';
      let userType = '2'; // 用户类型  零售通用户 1     非零售通用户2
      if (!search) return;
      const params: any = UrlParam.parseUrlQueryString(search);
      if (params?.channel === ChannelIdType.NEW_RETAIL && params?.channelId !== ChannelIdType.NEW_RETAIL) {
        setShowForm(false);
        setFailText(intl.get('qrcode.signIn.pleaseScanWithXiaomiRetail'));
        (window as any).onetrack('track', 'view', {
          tip: '310.593.0.1.46889',
        })
        return
      } else {
        setChannel(params.channel)
      }
      setQrCodeId(params.id);
      if (params?.qrCodeName) {
        setQrCodeName(params.qrCodeName);
      }
      if (params?.named) {
        setPreferredName(params.named);
        setWelcomeText(params.named);
        userType = '1'
      }
      if (params?.account) {
        setXiaomiRetailAccount(params.account);
        setShowSelectMid(false)
      }
      if (params?.mid) {
        setMid(params.mid);
      }
      if (params?.trainingFeedback) {
        setTrainingFeedback(params.trainingFeedback);
      }
      if (params?.region) {
        setSelectedCountryKey(params.region);
        setIsClickCountry(true);
      }
      if (params?.jobValue) {
        setJobValue(params.jobValue);
      }
      if (params?.jobTitle) {
        setJobTitle(params.jobTitle);
      }
      if (params?.org_name) {
        setOrgName(params.org_name);
      }
      if (params?.org_id) {
        setOrgId(params.org_id);
      }
      if (params?.siteId) {
        setSiteId(params.siteId);
      }
      getQrCodeEffective(params.id, params.jobValue, params.channel, userType, params.region, params?.mid)
    } catch (e) {
      // ignore
    }
  }

  // 过滤搜索筛选国家列表
  const countryList = useMemo(() => {
    return publishAreaList.filter((item) => {
      return item.areaName.includes(countryName)
    })
  }, [publishAreaList, countryName])

  useEffect(() => {
    (window as any).onetrack('track', 'view', {
      tip: '310.593.0.1.46884',
    })
    getUrlParamVal()
  }, [])

  const getQueryRetailerByArea = useCallback(() => {
    setIsLoadedRetailer(false)
    queryRetailerByArea({
      qrCodeManagementId: qrCodeId,
      areaId: selectedCountryKey,
      pageNo: pageNo,
      pageSize: PAGE_SIZE,
      retailerName: retailerName
    }, dnsName)
    .then((res: any) => {
      if (res?.code === 0) {
        if (pageNo === 1) {
          setRetailerList(res?.data?.records || [])
          setTotalPages(res?.data?.totalPages)
          setTotalRecords(res?.data?.totalRecords)
          if (res?.data?.records.length === 1 && retailerName === '') {
            setSelectedRetailer(res?.data?.records[0].name)
            setSelectedRetailerKey(res?.data?.records[0].code)
          } else {
            setSelectedRetailer('')
            setSelectedRetailerKey('')
          }
        } else {
          setRetailerList([...retailerList, ...res?.data?.records])
        }
      } else {
        setFailText(intl.get('qrcode.signIn.toast'))
      }
      setIsLoadedRetailer(true)
    })
  }, [selectedCountryKey, pageNo, retailerName, retailerList, qrCodeId])


  useEffect(() => {
    retailerTimer.current = setTimeout(() => {
      if (!selectedCountryKey) return;
      getQueryRetailerByArea()
    }, 1000)
    return () => {
      if (retailerTimer.current) {
        clearTimeout(retailerTimer.current)
      }
    }
  }, [selectedCountryKey, retailerName, pageNo])


  const signIn = () =>{
    if (preferredName === '') {
      showToast(intl.get('qrcode.signIn.preferredNameTip'))
      setIsAllEmptyShowTip(true)
      return;
    }
    if (selectedCountryKey === '') {
      showToast(intl.get('qrcode.signIn.countryOrRegionTip'))
      setIsAllEmptyShowTip(true)
      return;
    }
    // if (selectedChannelTypeKey === '' && channel === ChannelIdType.RMS) {
    //   showToast(intl.get('qrcode.signIn.channelTypeTip'))
    //   setIsAllEmptyShowTip(true)
    //   return;
    // }
    // if (selectedRetailerKey === '' && channel === ChannelIdType.RMS) {
    //   showToast(intl.get('qrcode.signIn.retailerTip'))
    //   return;
    // }
    if (xiaomiRetailAccount === '' && isHaveMid) {
      showToast(intl.get('qrcode.signIn.xiaomiRetailAccountTip'))
      setIsAllEmptyShowTip(true)
      return;
    }
    if (selectedCountryKey === '' && channel === ChannelIdType.RMS) {
      showToast(intl.get('qrcode.signIn.countryOrRegionTip'))
      setIsAllEmptyShowTip(true)
      return;
    }
    let params: any = {
      employeeName: preferredName,
      country: selectedCountryKey,
      note: comment,
      // storeType: '',
      // retailer: selectedRetailer,
      mid: mid,
      retailAccount: xiaomiRetailAccount,
      qrCodeManagementId: qrCodeId,
    }
    if (trainingFeedback === '1') {
      let isSelectAll = true;
      satisfactionData.forEach((item, index) => {
        params[`q${index + 1}Score`] = item.satisfaction;
        if (item.satisfaction === 0) {
          isSelectAll = false;
        }
      })
      if (!isSelectAll) {
        showToast(intl.get('qrcode.signIn.rateEachItemTip'))
        setIsAllEmptyShowTip(true)
        return;
      }
    }
    if (jobValue) {
      params.userTitle = `${jobValue}-${jobTitle}` ;
    }
    if (channel === ChannelIdType.RMS && selectedRetailerKey) {
      params.retailer = selectedRetailerKey + '!-!' + selectedRetailer;
    } else if (channel === ChannelIdType.RMS && retailer) {
      params.retailer = retailer;
    } else {
      params.retailer = orgId + '!-!' + orgName;
    }

    if (channel === ChannelIdType.RMS) {
      params.channelType = selectedChannelTypeKey;
    } else {
      params.storeType = siteId;
    }
    (window as any).onetrack('track', 'view', {
      tip: '310.593.0.1.46885',
    })
    submitScanInfo(params, dnsName).then((res: any) => {
      if (res?.code === 0) {
        setShowForm(false)
        setSubmitSuccess(true)
      } else {
        setFailText(intl.get('qrcode.signIn.toast'))
      }
    })
  }

  return showForm ? (
    <div className={[styles['signInContainer'], !showSelectMid ? styles['appExtraPadding'] : ''].join(' ')}>
      {
        showSelectMid ? <div className={styles['signInBanner']}>
          <div className={styles['signInBannerContent']}>
            <div className={styles['signInTitle']}>
              <span>{qrCodeName}</span>
            </div>
          </div>
        </div> : null
      }
      

      <div className={styles['signInContent']}>
        <div className={styles['signInContentHead']}>
          <img src={welcomeIcon} alt="" className={styles['signInContentHeadIcon']} />
          <span>{intl.get('qrcode.signIn.welcome', { name: welcomeText })}</span>
        </div>
        {
          welcomeText === WELCOMETEXT ? <div>
            <div className={styles['signInContentItem']}>
              <div className={styles['signInContentTitle']}>
                {intl.get('qrcode.signIn.preferredName')}
                <span className={styles['signInContentTitleRequired']}>*</span>
              </div>
              <div className={styles['signInContentInputBox']}>
                <input type="text" disabled={!showSelectMid} className={[styles['signInContentInput']].join(' ')} placeholder={intl.get('qrcode.signIn.pleaseInput')} onChange={updatePreferredName} value={preferredName} />
              </div>
            </div>
            <div className={[styles['signInContentItemLine'], isAllEmptyShowTip && preferredName === '' ? styles['signInContentItemLineRed'] : null].join(' ')}>
              {
                isAllEmptyShowTip && preferredName === '' ? intl.get('qrcode.signIn.emptyContent2') : null
              }
            </div>
          </div>: null
        }
        

        {
          showSelectMid ? (
          <div>
            <div className={styles['signInContentItem']}>
              <div className={styles['signInContentTitle']}>
                {intl.get('qrcode.signIn.haveMid')}
                <span className={styles['signInContentTitleRequired']}>*</span>
              </div>
              <div className={styles['signInContentRadioBox']}>
                <div className={styles['signInContentRadioItem']} onClick={() => setIsHaveMid(()=> true)}>
                  <img src={isHaveMid ? radioActive : radio} alt="" />
                  <span className={[ isHaveMid ? styles['radioActive'] : '' ].join(' ')}>{intl.get('qrcode.signIn.yes')}</span>
                </div>
                <div className={styles['signInContentRadioItem']} onClick={() => setIsHaveMid(() => false)}>
                  <img src={isHaveMid ? radio : radioActive} alt="" />
                  <span className={[ !isHaveMid ? styles['radioActive'] : '' ].join(' ')}>{intl.get('qrcode.signIn.no')}</span>
                </div>
              </div>
            </div>
            <div className={styles['signInContentItemLine']}></div>
          </div>
          ) : null
        }
        
        
        {
          isHaveMid ? (
            <div>
              <div className={styles['signInContentItem']}>
                <div className={styles['signInContentTitle']}>
                  {intl.get('qrcode.signIn.xiaomiAccount')}
                  <span className={styles['signInContentTitleRequired']}>*</span>
                </div>
                <div className={styles['signInContentInputBox']}>
                  <input type="text" disabled={!showSelectMid} className={[styles['signInContentInput']].join(' ')} placeholder={intl.get('qrcode.signIn.pleaseInput')} onChange={updateXiaomiRetailAccount} value={xiaomiRetailAccount} />
                </div>
              </div>
              <div className={[styles['signInContentItemLine'], isAllEmptyShowTip && xiaomiRetailAccount === '' ? styles['signInContentItemLineRed'] : null].join(' ')}>
                {
                  isAllEmptyShowTip && xiaomiRetailAccount === '' ? intl.get('qrcode.signIn.emptyContent2') : null
                }
              </div>
            </div>
          ) : null
        }
        
        <div>
          <div className={styles['signInContentItem']}>
            <div className={styles['signInContentTitle']}>
              {intl.get('qrcode.signIn.countryOrRegion')}
              <span className={styles['signInContentTitleRequired']}>*</span>
            </div>
            <div className={styles['signInContentSelect']} onClick={() => {
              if (isClickCountry || countryList.length === 1) {
                return false;
              }
              setShowCountry(true)
            }}>
              <span style={{color: selectedCountry ? '#333333' : '#BBBBBB'}}>{selectedCountry ? selectedCountry : intl.get('qrcode.signIn.pleaseSelect')}</span>
              <img src={downArrow} alt="" />
            </div>
          </div>
          <div className={[styles['signInContentItemLine'], isAllEmptyShowTip && selectedCountryKey === '' ? styles['signInContentItemLineRed'] : null].join(' ')}>
            {
              isAllEmptyShowTip && selectedCountryKey === '' ? intl.get('qrcode.signIn.emptyContent1') : null
            }
          </div>
        </div>
        {
          channel === ChannelIdType.RMS && (retailerList.length && channelList.length) ? <div>
            <div className={styles['signInContentItem']}>
              <div className={styles['signInContentTitle']}>
                { intl.get('qrcode.signIn.channelType') }
              </div>
              <div className={styles['signInContentSelect']} onClick={() => setShowChannelType(true)}>
                <span style={{color: selectedChannelType ? '#333333' : '#BBBBBB'}}>{selectedChannelType ? selectedChannelType : intl.get('qrcode.signIn.pleaseSelect')}</span>
                <img src={downArrow} alt="" />
              </div>
            </div>
            <div className={styles['signInContentItemLine']}>
            </div>
          </div> : channel === ChannelIdType.NEW_RETAIL ? <div>
            <div className={styles['signInContentItem']}>
              <div className={styles['signInContentTitle']}>
                { intl.get('qrcode.signIn.storeType') }
              </div>
              <div className={styles['signInContentSelect']}>
                <span style={{color: '#333333'}}>{ siteId ? SiteId[siteId as unknown as keyof typeof SiteId] : '' }</span>
              </div>
            </div>
            <div className={styles['signInContentItemLine']}>
            </div>
          </div> : null
        }
        
        {
          channel === ChannelIdType.RMS && retailerList.length && isLoadedRetailer ? <div className={styles['signInContentItem']}>
            <div className={styles['signInContentTitle']}>
              { intl.get('qrcode.signIn.retailer') }
            </div>
            <div className={styles['signInContentSelect']} onClick={() => {
              if (retailerList.length === 1 && retailerName === '') {
                return false;
              }
              setShowRetailer(true)
            }}>
              <span style={{color: selectedRetailer ? '#333333' : '#BBBBBB'}}>{selectedRetailer ? selectedRetailer : intl.get('qrcode.signIn.pleaseSelect')}</span>
              <img src={downArrow} alt="" />
            </div>
          </div> : channel === ChannelIdType.RMS && showSelectMid && selectedCountryKey && isLoadedRetailer ? <div>
            <div className={styles['signInContentItem']}>
              <div className={styles['signInContentTitle']}>
                { intl.get('qrcode.signIn.retailer') }
              </div>
              <div className={styles['signInContentInputBox']}>
                <input type="text" className={[styles['signInContentInput']].join(' ')} placeholder={intl.get('qrcode.signIn.pleaseInput')} onChange={updateRetailer} value={retailer} />
              </div>
            </div>
          </div> : channel === ChannelIdType.NEW_RETAIL ? <div className={styles['signInContentItem']}>
            <div className={styles['signInContentTitle']}>
              { intl.get('qrcode.signIn.store') }
            </div>
            <div className={styles['signInContentSelect']}>
              <span style={{color: '#333333'}}>{ orgName }</span>
            </div>
          </div> : null
        }
      </div>
      
      {
        trainingFeedback === '1' ? (
          <Satisfaction satisfactionData={satisfactionData} updateSatisfaction={updateSatisfaction} isAllEmptyShowTip={isAllEmptyShowTip} />
        ) : null
      }
      <div className={styles['signInContentComment']}>
        <div className={styles['signInContentHead']}>
          <img src={commentIcon} alt="" className={styles['signInContentHeadIcon']} />
          <span>{intl.get('qrcode.signIn.commentThisCourse')}</span>
        </div>
        <div className={styles['signInContentTextareaBox']}>
          <textarea className={[styles['signInContentTextarea']].join(' ')} placeholder={intl.get('qrcode.signIn.pleaseInput')} onChange={updateComment} value={comment} />
          <div className={styles['signInContentTextareaCount']}>{comment.length}/300</div>
        </div>
      </div>
      <div className={styles['signInContentButton']}>
        <div className={styles['signInContentButtonText']} onClick={signIn}>{intl.get('qrcode.signIn.signIn')}</div>
      </div>
      <ChannelType showChannelType={showChannelType} setShowChannelType={setShowChannelType} selectedChannelTypeKey={selectedChannelTypeKey} setSelectedChannelType={setSelectedChannelType} channelList={channelList} setSelectedChannelTypeKey={setSelectedChannelTypeKey} />
      <DownSelectSearch
        title={intl.get('qrcode.signIn.retailerName')}
        showDownSelectSearch={showRetailer}
        setShowDownSelectSearch={setShowRetailer}
        selectedDownSelectSearchKey={selectedRetailerKey}
        setSelectedDownSelectSearch={setSelectedRetailer}
        setSelectedDownSelectSearchKey={setSelectedRetailerKey}
        list={retailerList}
        searchValue={retailerName}
        setSearchValue={setRetailerName}
        lable="name"
        value="code"
        totalPages={totalPages}
        totalRecords={totalRecords}
        PAGE_SIZE={PAGE_SIZE}
        pageNo={pageNo}
        setPageNo={setPageNo}
      />
      <DownSelectSearch
        title={intl.get('qrcode.signIn.countryName')}
        showDownSelectSearch={showCountry}
        list={countryList}
        setShowDownSelectSearch={setShowCountry}
        selectedDownSelectSearchKey={selectedCountryKey}
        setSelectedDownSelectSearch={setSelectedCountry}
        setSelectedDownSelectSearchKey={setSelectedCountryKey}
        setDnsName={setDnsName}
        searchValue={countryName}
        setSearchValue={setCountryName}
        lable="areaName"
        value="areaId"
      />
      {/* <Toast content="Please select the region/country first." /> */}
    </div>
  ) : submitSuccess ? (
    <div className={styles['signInSuccessContainer']}>
      <div className={styles['signInSuccessContent']}>
        <img src={successIcon} alt="" />
        <div>{intl.get('qrcode.signIn.submitSuccess')}</div>
      </div>
    </div>
  ) : (
    <div className={styles['signInFailContainer']}>
      <div className={styles['signInFailContent']}>
        {failText}
      </div>
    </div>
  )
}

export default SignInPage